import { Injectable } from '@angular/core';
import {CommonService} from './common.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReturnOrderService {

  constructor(private commonService: CommonService,
              private httpClient: HttpClient) { }


  public checkSerialNumber(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`return_command/check_serial`, body).subscribe((result) => {
        resolve(result);
      }, error => {
        reject({message: error.message});
      });
    });
  }

  public updateSerialNumber(body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient.put(`return_command/change_serial`, body).subscribe((result) => {
        resolve(result);
      }, error => {
        reject({message: error.message});
      });
    });
  }
}
